import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-comments-dialog',
  templateUrl: './comments-dialog.component.html',
  styleUrls: ['./comments-dialog.component.css']
})
export class CommentsDialogComponent {
  constructor(private dialogRef: MatDialogRef<CommentsDialogComponent>) {
  }

  ngOnInit(): void {
  }
  submit(userComment:string){
    // setTimeout(()=>{
    //   this.spinner.show();
    // },2000)
    this.dialogRef.close({userComment: userComment, update: true});
  }
}
